import { useMediaQuery } from '../../utils/useMediaQuery';
import MegaNav from './MegaNav';
import MobileDrawer from './MobileDrawer';

/**
 * Responsive navigation entry point.
 *
 * Renders the desktop nav on lg+ (≥1024 px) and the mobile slide-in drawer
 * below that breakpoint. The text labels + CTA need that width to fit without
 * crowding. The switch is driven by `useMediaQuery` so only one tree is in the
 * DOM at a time.
 */
export default function NavBar() {
  const isDesktop = useMediaQuery(1024);
  return isDesktop ? <MegaNav /> : <MobileDrawer />;
}
